import React, { Component } from "react";
import { Button, ButtonGroup } from "reactstrap";
import { connect } from "react-redux";
import ReactTable from "react-table";
import "react-table/react-table.css";
import * as actions from "../../actions";
import { venuesDataColumns } from "./Components/dataColumns";
import { Spinner } from "react-activity";
import "react-activity/dist/react-activity.css";
import NewVenueModal from "./Components/NewVenueModal";
import DeleteVenueModal from "./Components/DeleteVenueModal";
import "./Venues.css";

class Venues extends Component {
  componentDidMount() {}

  updateVenueProps = payload => {
    this.props.updateVenueProps(payload);
  };
  mergeVenueProps = payload => {
    this.props.mergeVenueProps(payload);
  };
  deleteVenueProps = payload => {
    this.props.deleteVenueProps(payload);
  };
  toggleVenueSelection = venue => {
    const selectedVenueIds = this.props.venuesReducer.selectedVenueIds || [];
    const venueId = String(venue.id);
    const isSelected = selectedVenueIds.includes(venueId);
    this.updateVenueProps([
      {
        prop: "selectedVenueIds",
        value: isSelected ? selectedVenueIds.filter(id => id !== venueId) : [...selectedVenueIds, venueId]
      }
    ]);
  };
  toggleAllVenueSelection = () => {
    const venueRows = this.props.venuesReducer.venues && this.props.venuesReducer.venues.data
      ? this.props.venuesReducer.venues.data
      : [];
    const selectableVenueIds = venueRows
      .filter(venue => venue && venue.id != null && !venue.isDeleting)
      .map(venue => String(venue.id));
    const selectedVenueIds = this.props.venuesReducer.selectedVenueIds || [];
    const allVisibleSelected =
      selectableVenueIds.length > 0 && selectableVenueIds.every(id => selectedVenueIds.includes(id));
    this.updateVenueProps([
      {
        prop: "selectedVenueIds",
        value: allVisibleSelected ? [] : selectableVenueIds
      }
    ]);
  };
  openDeleteVenueModal = venuesToDelete => {
    const venueRows = this.props.venuesReducer.venues && this.props.venuesReducer.venues.data
      ? this.props.venuesReducer.venues.data
      : [];
    const deleteVenueIndexes = venuesToDelete
      .map(venueOrIndex => {
        if (typeof venueOrIndex === "number") {
          return venueOrIndex;
        }

        return venueRows.findIndex(
          venue =>
            venue &&
            (venue === venueOrIndex ||
              String(venue.id) === String(venueOrIndex.id))
        );
      })
      .filter(index => index >= 0);

    if (deleteVenueIndexes.length === 0) {
      return;
    }

    this.updateVenueProps([
      { prop: "deleteVenueIndexes", value: deleteVenueIndexes },
      { prop: "isDeleteVenueModalOpen", value: true }
    ]);
  };
  deleteVenue = venueOrIndex => {
    this.openDeleteVenueModal([venueOrIndex]);
  };
  deleteSelectedVenues = () => {
    const { selectedVenueIds, venues } = this.props.venuesReducer;
    const venueRows = venues && venues.data ? venues.data : [];
    const venuesToDelete = venueRows.filter(venue => selectedVenueIds.includes(String(venue.id)));
    this.openDeleteVenueModal(venuesToDelete);
  };
  confirmDeleteVenue = () => {
    const { deleteVenueIndexes, venues } = this.props.venuesReducer;
    const venueRows = venues && venues.data ? venues.data : [];
    const venuesToDelete = deleteVenueIndexes
      .map(index => (index != null ? venueRows[index] : null))
      .filter(Boolean)
      .map((venue, index) => ({ ...venue, index: deleteVenueIndexes[index] }));

    if (venuesToDelete.length > 0) {
      this.props.deleteVenues(venuesToDelete);
    }

    this.updateVenueProps([
      { prop: "deleteVenueIndexes", value: [] },
      { prop: "isDeleteVenueModalOpen", value: false }
    ]);
  };
  createVenues = venues => {
    this.props.createVenues(venues);
  };
  paginate = (tableState, tableInstance) => {
    let param = {};
    if (tableState.sorted.length !== 0) {
      param.sort_column = tableState.sorted[0].id;
      param.sort_type = tableState.sorted[0].desc ? "desc" : "asc";
    }
    if (tableState.filtered.length !== 0) {
      param.filters = [];
      for (let i = 0; i < tableState.filtered.length; i++) {
        // tableState.filtered[i].id
        param.filters.push({ filter_column: tableState.filtered[i].id, filter_value: tableState.filtered[i].value });
      }
    }
    param.page_size = tableState.pageSize;
    this.props.getVenues("venues", tableState.page + 1, param);
  };

  render() {
    const {
      venues,
      isVenuesTableEditable,
      isVenueSaving,
      isNewVenueModalOpen,
      newVenues,
      isVenueCreating,
      isVenueLoading,
      totalScore,
      isDeleteVenueModalOpen,
      deleteVenueIndexes,
      selectedVenueIds
    } = this.props.venuesReducer;
    const venueRows = venues && venues.data ? venues.data : [];
    const { last_page } = venues;
    const efficiencyEnabledCount = venueRows.filter(venue => venue && parseInt(venue.efficiency_enabled, 10) === 1).length;
    const deleteVenueRecords = deleteVenueIndexes.map(index => venueRows[index]).filter(Boolean);
    const selectableVenueIds = venueRows
      .filter(venue => venue && venue.id != null && !venue.isDeleting)
      .map(venue => String(venue.id));
    const allVisibleSelected =
      selectableVenueIds.length > 0 && selectableVenueIds.every(id => selectedVenueIds.includes(id));
    return (
      <div className="venues-page">
        <NewVenueModal
          isOpen={isNewVenueModalOpen}
          updateVenueProps={this.updateVenueProps}
          mergeVenueProps={this.mergeVenueProps}
          deleteVenueProps={this.deleteVenueProps}
          createVenues={this.createVenues}
          newVenues={newVenues}
          isVenueCreating={isVenueCreating}
        />
        <DeleteVenueModal
          isOpen={isDeleteVenueModalOpen}
          venues={deleteVenueRecords}
          isDeleting={deleteVenueRecords.some(venue => !!venue.isDeleting)}
          onCancel={() => {
            this.updateVenueProps([
              { prop: "deleteVenueIndexes", value: [] },
              { prop: "isDeleteVenueModalOpen", value: false }
            ]);
          }}
          onConfirm={this.confirmDeleteVenue}
        />

        <div className="venues-page__hero">
          <div>
            <div className="venues-page__eyebrow">Scheduling Inputs</div>
            <h1 className="venues-page__title">Venues</h1>
            <p className="venues-page__copy">
              Curate the venue catalog, scoring, and efficiency participation that drive the schedule builder.
            </p>
          </div>

          <div className="venues-page__stats">
            <div className="venues-stat">
              <span className="venues-stat__value">{venueRows.length}</span>
              <span className="venues-stat__label">Visible venues</span>
            </div>
            <div className="venues-stat">
              <span className="venues-stat__value">{totalScore}</span>
              <span className="venues-stat__label">Visible score total</span>
            </div>
            <div className="venues-stat">
              <span className="venues-stat__value">{efficiencyEnabledCount}</span>
              <span className="venues-stat__label">Efficiency enabled</span>
            </div>
          </div>
        </div>

        <div className="venues-toolbar">
          <div className="venues-toolbar__group">
            <ButtonGroup>
              <Button
                color={"faiz3"}
                onClick={() => {
                  this.updateVenueProps([{ prop: "isNewVenueModalOpen", value: true }]);
                }}
              >
                <i className={"fa fa-plus"} /> New Venue
              </Button>
              <Button
                color={"danger"}
                onClick={this.deleteSelectedVenues}
                disabled={selectedVenueIds.length === 0}
              >
                <i className={"fa fa-trash"} /> Delete Selected
              </Button>
              <Button
                color={"faiz1"}
                onClick={() => {
                  this.props.getVenues("venues", 1, {});
                }}
              >
                Refresh
              </Button>
            </ButtonGroup>
          </div>

          <div className="venues-toolbar__group">
            <ButtonGroup>
              {isVenuesTableEditable ? (
                <Button
                  color={"faiz2"}
                  onClick={() => {
                    this.props.saveVenues(venues);
                  }}
                  disabled={isVenueSaving}
                >
                  {isVenueSaving ? (
                    <>
                      <Spinner size={10} animating={true} color={"white"} />
                      &nbsp;
                    </>
                  ) : null}
                  <i className={"fa fa-floppy-o"} /> Save
                </Button>
              ) : (
                <Button
                  color={"faiz1"}
                  onClick={() => {
                    this.props.updateVenueProps([{ prop: "isVenuesTableEditable", value: true }]);
                  }}
                  disabled={isVenueSaving}
                >
                  <i className={"fa fa-pencil"} /> Edit
                </Button>
              )}
            </ButtonGroup>
          </div>
        </div>

        <div className="venues-card">
          <div className="venues-card__header">
            <div className="venues-card__eyebrow">Venue Directory</div>
            <h2 className="venues-card__title">Active Venues</h2>
            <p className="venues-card__copy">
              Search, review, and edit venue data inline, then save only the rows that changed.
            </p>
          </div>

          <div className="venues-table-shell">
            <ReactTable
              data={venueRows}
              columns={venuesDataColumns(
                this.updateVenueProps,
                isVenuesTableEditable,
                this.deleteVenue,
                selectedVenueIds,
                this.toggleVenueSelection,
                this.toggleAllVenueSelection,
                allVisibleSelected
              )}
              className="-highlight -striped venues-table"
              defaultPageSize={10}
              filterable
              manual
              pages={last_page != null ? last_page : -1}
              onFetchData={this.paginate}
              loading={isVenueLoading}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ venuesReducer }) => ({
  venuesReducer
});

export default connect(
  mapStateToProps,
  actions
)(Venues);
